module.exports = __webpack_public_path__ + "img/0fbd951.jpg";